var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKakaoIcon = function SvgKakaoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.058.653C5.835.653.818 4.667.818 9.54c0 3.163 2.087 5.933 5.218 7.515l-1.06 3.958a.337.337 0 0 0 .08.345.353.353 0 0 0 .234.088.338.338 0 0 0 .192-.08l4.56-3.075c.674.093 1.352.141 2.032.145 6.214 0 11.24-4.015 11.24-8.896 0-4.882-5.042-8.888-11.256-8.888Z",
    fill: "#392020"
  })));
};
export default SvgKakaoIcon;